import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const educationData = [
    {
        id: 1,
        name: 'B.Sc in Computer Science and Engineering',
        description: 'Now I am studying at Uttara University.',
        date: '2019-2022'
    }, {
        id: 2,
        name: 'Higher Secondary Certificate (HSC)',
        description: 'In 2015 I passed HSC Exam. My grade is 4.92 (Out of 5.00). I was in the science department. My school name was Agricultural University College.',
        date: '2013 - 2015'
    }, {
        id: 3,
        name: 'Secondary School Certificate (SSC)',
        description: 'In 2013 I passed SSC Exam. My grade is 5.00 (Out of 5.00). I was in the science department. My school name was Jamalpur Zilla School.',
        date: '2017-2018'
    }
];

const Education = () => {
    return (
        <div className="education padd-15">
            <h3 className="title">Education</h3>
            <div className="row">
                <div className="timeline-box padd-15">
                    <div className="timeline shadow-dark">
                        {
                            educationData.map(education => <div key={education.id} className="timeline-item">
                                <div className="circle-dot"></div>
                                <h6 className="timeline-date"><FontAwesomeIcon icon={faCalendarAlt} /> {education.date}</h6>
                                <h4 className="timeline-title">{education.name}</h4>
                                <p className="timeline-text">{education.description}</p>
                            </div>)
                        }

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Education;